import React from "react";

const SvgIcnOperateSetting1 = props => (
  <svg
    id="icn_operate_setting_1_svg__\u30EC\u30A4\u30E4\u30FC_1"
    data-name="\u30EC\u30A4\u30E4\u30FC 1"
    width={24}
    height={24}
    {...props}
  >
    <defs>
      <style>{".icn_operate_setting_1_svg__cls-2{fill:#4a4b4c}"}</style>
    </defs>
    <path
      d="M12 1a11 11 0 1 0 11 11A11 11 0 0 0 12 1zm0 20a9 9 0 1 1 9-9 9 9 0 0 1-9 9z"
      fillRule="evenodd"
      fill="#4a4b4c"
    />
    <path
      className="icn_operate_setting_1_svg__cls-2"
      transform="rotate(45 8.75 13.714)"
      d="M5.93 12.71h5.62v2H5.93z"
    />
    <path
      className="icn_operate_setting_1_svg__cls-2"
      transform="rotate(135 13.092 11.908)"
      d="M7.74 10.91h10.71v2H7.74z"
    />
  </svg>
);

export default SvgIcnOperateSetting1;
